import { withI18n } from 'panda-i18n';
import locale from '@/locales';
import { CnButtonGroup as UICnButtonGroup } from './cn-button-group';
export var CnButtonGroup = withI18n(UICnButtonGroup, { locale: locale });
